/**
 * 会员信息
 */
import React from 'react';
import messager from '../../ui/messager';
import { Input, Row, Col, Button ,Select, Icon, Tooltip} from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import Loading from '../../ui/Loading';
import BatchVehicleProjectEdit from './BatchVehicleProjectEdit';
import { global_data } from '../../ui/auth'


class BatchVehicleProjectIndex extends React.Component {

    columns = [ {
        title: '公司名称',
        dataIndex: 'name',
        width: '15%',
    }
    , {
        title: '账单首日车数',
        dataIndex: 'totalVehicleNumber',
        width: '5%'
    }
    , {
        title: '场内车数',
        dataIndex: 'insideVehicleNumber',
        width: '5%',
    }
    // ,{
    //     title: '已使用天数',
    //     dataIndex: 'usedDayNumber',
    //     width: '7%'
    // }
    ,{
        title: '车费每车每天',
        dataIndex: 'unitPrice',
        width: '5%',
    }
    ,{
        title: '公司备注',
        dataIndex: 'remark',
        width: '10%'
    }, {
        title: '创建时间',
        dataIndex: 'createTime',
        width: '10%',
    }, {
        title: '负责人',
        dataIndex: 'creator',
        width: '5%'
    }
    , {
        title: '状态',
        dataIndex: 'state',
        width: '5%',
        format: { 0: '停用', 1: '启用' },
        render: (text, record, index) => (
            <div>
                <Tooltip title={record.state ?  "切换禁用": "切换启用"}>
                    {global_data.authCode.includes("BARRIER_BATCH_VEHICLE_PROJECT_ENABLE")?
                    <Button
                    onClick={this.changeState.bind(this, record)}
                    style={{ color: record.state ? "black" :  "red"}}
                    >
                    {record.state ? "启用" :"禁用" }
                    </Button>
                    :""}
                </Tooltip>
            </div>
          ),
    }
    ,{
        title: '操作',
        dataIndex: 'id',
        width: '8%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("BARRIER_BATCH_VEHICLE_PROJECT_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {/* <Tooltip title="启用">
                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.finish.bind(this, text)} />
                </Tooltip>
                <Tooltip title="停用">
                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.start.bind(this, text)} />
                </Tooltip> */}
            </div>
        )
    }
];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false,
        visible: false,
        editData: {}
    };

    add = () => {
        let editData=this.state;
        editData.unitPrice=0.0;
        editData.totalVehicleNumber=0;
        this.setState({ editData: editData, visible: true });
    }

    update = (info, e) => {
        this.setState({ editData: info, visible: true });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    selectChange = (value) => {
        let { queryData } = this.state;
        queryData["state"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    changeState = (data, e) => {
        if(data.state){
            messager.alert("禁用公司将不会在入库列表中展示");
        }
        http.post({
            url: "/barrier/batchVehicleProject/state",
            data: { 
                id:data.id,
                state: data.state ? 0 : 1 
            },
            success: () => {
                this.state.loadData(this.state.queryData);
            },
        });
    }

        
    
    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="公司名称等关键字"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 400 }}
                                />
                                <Select onChange={this.selectChange} allowClear={true} style={{ width: "150px", marginLeft: '10px' }}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="1">启用</Select.Option>
                                    <Select.Option value="0">停用</Select.Option>
                                </Select>
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("BARRIER_BATCH_VEHICLE_PROJECT_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/barrier/batchVehicleProject/page"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <BatchVehicleProjectEdit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </div>
        )
    }
}

export default BatchVehicleProjectIndex;